(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pcard-slider')) {
    class PcardSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.pcard__track');
        this.dots = Array.from(this.querySelectorAll('[data-pcard-dot]'));
        if (!this.track || !this.dots.length) return;
        let raf = null;
        this.track.addEventListener(
          'scroll',
          () => {
            if (raf) return;
            raf = requestAnimationFrame(() => {
              raf = null;
              this.update();
            });
          },
          { passive: true }
        );
        this.addEventListener('click', (e) => {
          const dot = e.target.closest('[data-pcard-dot]');
          if (!dot) return;
          e.preventDefault();
          this.track.scrollTo({
            left: this.track.clientWidth * Number(dot.dataset.pcardDot),
            behavior: 'smooth',
          });
        });

        // Pointer drag-to-scroll (mouse only — touch/pen use native scroll-snap).
        // A plain click must open the PDP, so we only enter "swipe mode"
        // (is-dragging + pointer capture) once the pointer has moved past the
        // threshold — NOT on pointerdown. Capturing on pointerdown would let the
        // browser retarget the click to the track and swallow the slide link's
        // navigation on a simple click.
        let armed = false;
        let dragging = false;
        let pointerId = null;
        let startX = 0;
        let startScroll = 0;
        let moved = 0;
        const DRAG_THRESHOLD = 5;
        this.track.addEventListener('dragstart', (e) => e.preventDefault());
        this.track.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          armed = true;
          dragging = false;
          moved = 0;
          startX = e.clientX;
          startScroll = this.track.scrollLeft;
          pointerId = e.pointerId;
        });
        this.track.addEventListener('pointermove', (e) => {
          if (!armed) return;
          const dx = e.clientX - startX;
          moved = Math.max(moved, Math.abs(dx));
          if (!dragging) {
            // Still a click until the pointer clears the threshold.
            if (moved <= DRAG_THRESHOLD) return;
            dragging = true;
            this.track.classList.add('is-dragging');
            try {
              this.track.setPointerCapture(pointerId);
            } catch (_) {}
          }
          this.track.scrollLeft = startScroll - dx;
        });
        const endDrag = () => {
          if (!armed) return;
          armed = false;
          if (dragging) {
            this.track.classList.remove('is-dragging');
            try {
              this.track.releasePointerCapture(pointerId);
            } catch (_) {}
            const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            this.track.scrollTo({ left: this.track.clientWidth * i, behavior: 'smooth' });
          }
          dragging = false;
        };
        this.track.addEventListener('pointerup', endDrag);
        this.track.addEventListener('pointercancel', endDrag);
        // Suppress the slide's link navigation only when the pointer dragged.
        this.track.addEventListener(
          'click',
          (e) => {
            if (moved > DRAG_THRESHOLD) {
              e.preventDefault();
              e.stopPropagation();
            }
          },
          true
        );
      }
      update() {
        const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
        this.dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
      }
    }
    customElements.define('pcard-slider', PcardSlider);
  }
  } catch(e) { console.error(e); }
})();

})();
